import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useSkipPhoto(sessionId: string) {
  return useMutation(trpcOptions.app.skipPhoto.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }))
}
